import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deleteEmployee, listEmployee, employeeStatus } from './EmployeeServices';

const EmployeeList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "id", label: "ID", minWidth: 170 },
        { key: "f_name", label: "First Name", minWidth: 170 },
        { key: "l_name", label: "Last Name", minWidth: 170 },
        { key: "mobile_number", label: " Mobile Number", minWidth: 170 },
        { key: "email", label: "Email", minWidth: 170 },
        { key: "city", label: "City", minWidth: 170 },
        { key: "state", label: "State", minWidth: 170 },
        { key: "experience", label: "Experience", minWidth: 170 },
        { key: "job_role", label: "Job Role", minWidth: 170 },
        { key: "previous_company", label: "Previous Company", minWidth: 170 },
        { key: "resume_upload", label: "Resume", minWidth: 170 },
        { key: "skills", label: "Skills", minWidth: 170 },
    ];

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        listEmployee().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Job Seaker' list={true} link={PageRoutes.EMPLOYEE_ADD} value={"Add Job Seaker"} />
                            <CMTableList
                                // exportFileName="Office Branch"
                                // csvHeaders={["ID", "Name", "Removed"]}
                                // csvHeaderKeys={["id", "name", "removed"]}
                                blockService={employeeStatus}
                                listService={listEmployee}
                                deleteService={deleteEmployee}
                                showView={false}
                                showBlock={false}
                                editLink={PageRoutes.EMPLOYEE_EDIT}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default EmployeeList;
